import { gql } from "lib/apolloClient";
import { userNameFragment } from "modules/CommonFragments";

export const organizationStaffFragment = {
  staff: gql`
    fragment staff on Staff {
      ...userNameFields
      email
      profileImage
      roles
      isArchived
      courses: coursesV2 {
        edges {
          node {
            id
            title @skip(if: $skipTitle)
          }
        }
      }
      __typename
    }
    ${userNameFragment}
  `,
};

export const organizationCoursesFragment = {
  course: gql`
    fragment course on Course {
      id
      title
      profileImageData {
        url
        icon
        __typename
      }
      primaryGrade {
        id
      }
      subjects {
        id
        recommendedPhase @include(if: $shouldFetchRecommendedPhase) {
          gradeId
          phaseId
        }
      }
      grades {
        id
        name
        subjects {
          id
          name
          isArchived
          subjectGroup {
            id
            name
          }
        }
        yearGroup {
          id
          name
          examSession {
            id
            year
          }
        }
        displaySequence
        globalGrade {
          id
          uid
          name
          constants
        }
      }
    }
  `,
};

export const moduleAccessStaffFragment = {
  admin: gql`
    fragment moduleAdmin on CurriculumProgram {
      id
      moduleLvlAccessStaffs(input: { moduleNames: $entityType }) {
        moduleName
        staffs {
          ...staff
        }
      }
    }
    ${organizationStaffFragment.staff}
  `,
};
